angular.module('app').directive("fileread", ['uploadImageParams', 'logger', 'Utils',function (uploadImageParams, logger, Utils) {
    return {
        restrict: "E",
        scope: {
            callback: "&cb",
            imgLoad: "=",
        },
        link: function (scope, element, attributes) {
            var cb = !!scope.callback && scope.callback(),
                watchers = [];


            if (!!attributes.imgSrc) {
                Utils.getBlob(attributes.imgSrc, cb);
            }

            if (!!attributes.watch) {
                watchers.push(scope.$watch("imgLoad", function (newVal) {
                    if (!!newVal) {
                        Utils.checkFileAndMakeWarning(newVal, logger);

                        if (newVal.size > uploadImageParams.imageSiza) {
                            var fileSizeConvert = newVal.size / 1048576;
                            logger.logError("Max file size is 4MB. Your file is " + ' ' + fileSizeConvert.toFixed(2) + 'MB');
                            scope.imgLoad = undefined;

                        } else {
                            var fr = new FileReader();
                            fr.onloadend = function () {
                                !!cb && cb(Utils.fixImageBase64URL(newVal, fr.result));
                            };
                            fr.readAsDataURL(newVal);
                        }

                    }
                }))
            }

            scope.$on("$destroy", function () {
                var i = 0;
                while (watchers[i]) {
                    watchers[i]();
                    i++
                }
            })
        }
    }
}]);
